import React from 'react';
import ModalVideo from 'react-modal-video';
import PreLoginPage from '../core/PreLoginPage';
// ES6 class-style
class PlpvideoPlayer extends PreLoginPage {


    constructor(props) {
        super(props)
        this.state = {
            isOpen: false
        }
        this.openModal = this.openModal.bind(this)
        this.goNext = this.goNext.bind(this)
        this.goPrev = this.goPrev.bind(this)
        this.swiper = null
    }

    componentDidMount() {
        /* HmEventRegistry.fireEvent("INITIATE_GA_EVENT"); */
    }

    goNext() {
        if (this.swiper) this.swiper.slideNext()
    }

    goPrev() {
        if (this.swiper) this.swiper.slidePrev()
    }

    openModal(someValue) {
        this.setState({ isOpen: true })
        this.videoId = someValue
        console.log(this.videoId);
    }

    onClickDemoFn = () => {
        if (typeof this.props.demoFn === "function") {
            this.props.demoFn();
        }
    }

    getDemoFn = () => {
        return (
            <div className='col-md-12 mb-10 demobtn'>
                <span data-ga="Homework-Demovideo" onClick={this.onClickDemoFn} className="r-btn contactbtn">{this.rb("homework.demo")}</span>
            </div>
        )
    }

    render() {
        const videoId = '';
        const params = {
            slidesPerView: 1,
            spaceBetween: 30,
            loop: false,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
                nextButtonCustomizedClass: '.swp-next',
                prevButtonCustomizedClass: '.swp-prev'
            }
        }

        let country = this.props.country ? this.props.country : null;
        let url = window.hmplpvideoURL ? window.hmplpvideoURL[country] : null;
        let imgPath = window.hmplpvideoimgPath ? window.hmplpvideoimgPath[country] : null;

        return (
            (url && imgPath) ? (
                <section className="mtb video-container plp-homework-video">
                    <div className="row">
                        <div className="container">
                            <div data-ga="Homework-Demovideo" className="swiper-slide">
                                <div className="img-box popup-youtube single-video" onClick={this.openModal.bind(null, url)}>
                                    <img src={imgPath} alt="How HeyMath! really empowers Tutors and Teachers" />
                                    <a><span className="play-btn"></span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <ModalVideo channel='custom' isOpen={this.state.isOpen} url={this.videoId} autoplay={1} onClose={() => this.setState({ isOpen: false })} /> */}
                    <ModalVideo channel='youtube' isOpen={this.state.isOpen} videoId={this.videoId} onClose={() => this.setState({ isOpen: false })} />
                </section>
            ) : null

        );
    }
}

export default PlpvideoPlayer;


// WEBPACK FOOTER //
// ./src/views/common/PlpvideoPlayer.js